import {makeAutoObservable} from 'mobx';

/** What the app reads of the OIDC user (learning-oidc-client `User`). */
export interface SignedInUser {
    access_token?: string;
    profile?: {idString?: string};
}

class UserStore {
    private _user: SignedInUser | null = null;
    private _isLoading = false;
    private _error: string | null = null;

    constructor() {
        makeAutoObservable(this);
    }

    get user() {
        return this._user;
    }

    get isLoading() {
        return this._isLoading;
    }

    get error() {
        return this._error;
    }

    get isSignedIn() {
        return !!this._user;
    }

    get idString() {
        return this._user?.profile?.idString;
    }

    get accessToken() {
        return this._user?.access_token;
    }

    updateUser(user: SignedInUser | null) {
        // Only update if the user data has actually changed
        if (JSON.stringify(this._user) !== JSON.stringify(user)) {
            this._user = user;
        }
    }

    setLoading(isLoading: boolean) {
        this._isLoading = isLoading;
    }

    setError(error: string | null) {
        this._error = error;
    }

    reset() {
        this._user = null;
        this._isLoading = false;
        this._error = null;
    }
}

export const userStore = new UserStore();
